import { getScript } from 'js/utils/scripts.util';
import { useCallback } from 'react';

export const useDownloadSolusSDK = ({ solusClientURL }) => {
    return useCallback(async () => {
        if (!window.GcHtml5) {
            await getScript(solusClientURL);
        }

        return window.GcHtml5.createClient();
    }, [solusClientURL]);
};
